import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { toast } from "react-toastify";
import { format } from "date-fns";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const HolidayModal = ({ open, onClose, holidayId, reload }) => {
    const [name, setName] = useState("");
    const [date, setDate] = useState("");
    const [recurring, setRecurring] = useState(false);

    useEffect(() => {
        const fetchHoliday = async () => {
            if (!holidayId) return;
            try {
                const { data } = await api.get(`/holidays/${holidayId}`);
                setName(data.name);
                setDate(data.date);
                setRecurring(data.recurring);
            } catch (err) {
                toastError(err);
            }
        };
        fetchHoliday();
    }, [holidayId, open]);

    const handleClose = () => {
        setName("");
        setDate("");
        setRecurring(false);
        onClose();
    };

    const handleSaveHoliday = async () => {
        try {
            if (holidayId) {
                await api.put(`/holidays/${holidayId}`, { name, date, recurring });
                toast.success("Feriado atualizado com sucesso!");
            } else {
                await api.post("/holidays", { name, date, recurring });
                toast.success("Feriado criado com sucesso!");
            }
            handleClose();
            reload();
        } catch (err) {
            toastError(err);
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>{holidayId ? "Editar Feriado" : "Adicionar Feriado"}</DialogTitle>
            <DialogContent>
                <TextField
                    label="Nome do Feriado"
                    fullWidth
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    margin="dense"
                    variant="outlined"
                />
                <TextField
                    label="Data"
                    type="date"
                    fullWidth
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    margin="dense"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={recurring}
                            onChange={(e) => setRecurring(e.target.checked)}
                            color="primary"
                        />
                    }
                    label="Recorrente (repete todo ano)"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="secondary">
                    Cancelar
                </Button>
                <Button onClick={handleSaveHoliday} color="primary" variant="contained">
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default HolidayModal;
